import { styled } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { Grid } from "@mui/material";
import { colors } from "@zapalacorp/tokens";

export const ModalSection = styled("section")(() => ({
  width: "100%",
}));

export const ContentBox = styled(Grid)(() => ({
  backgroundColor: colors.gray50,
  borderRadius: "8px",
  padding: "16px",
  paddingTop: "12px",
  marginTop: "24px",
}));

export const AlldaySection = styled(Grid)(() => ({
  marginBottom: "16px",
}));

export const AlldayLabel = styled("span")(() => ({
  color: colors.gray600,
  fontFamily: "Manrope",
  fontSize: "16px",
  fontWeight: 400,
  lineHeight: "24px",
  letterSpacing: "0.5px",
}));

const styles = makeStyles(() => ({
  modal: {
    maxWidth: "442px !important",
  },
}));

export default styles;
